export function setVotedInStorage(): void {
  localStorage.setItem('autobahnplakate-voted-2', 'true')
}

export function hasVotedInStorage(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.localStorage.getItem('autobahnplakate-voted-2') === 'true'
  )
}

export function clearVotedInStorage(): void {
  localStorage.removeItem('autobahnplakate-voted-2')
}
